export default __webpack_public_path__ + "static/media/91XAS7_notice08.8fe56def.pdf";